import React from "react";
import {
  f7,
  Page,
  Card,
  CardContent,
  Preloader,
  Icon,
  BlockTitle,
  Block,
  Button,
} from "framework7-react";

import { API_URL } from "../../../api";
import PageBlock from "../../shared/pageBlock/pageBlock";

import Ev1La1 from "../../eventContainer/eventType-1/layout-1/Ev1La1";

var stylesheet;

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: false,
      showNextBtn: true,
      nextLoading: false,
      data: null,
    };
  }

  componentDidMount() {
    this.loadXhr();
    if (!stylesheet) {
      stylesheet = document.createElement("style");
      document.head.appendChild(stylesheet);
    }
    document.title = "Påmeldinger.no";
  }

  loadXhr(special_code) {
    const eid = this.props.f7route.params.id;

    this.setState({
      loading: true,
    });

    fetch(API_URL + "/event/get", {
      method: "POST",
      body: JSON.stringify({
        eid: eid,
        special_code: special_code,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.err_code === 0) {
          this.setState({
            loading: false,
            error: false,
            data: data,
          });
          //set document title
          document.title = data.title;
          //set color teme
          this.setColorTheme(data.options.theme_color);
        } else if (data.err_code === 19) {
          this.setState({
            loading: false,
            error: true,
            server_error: true,
            error_mgs: data.mgs,
          });
        } else {
          this.setState({
            loading: false,
            error: true,
            error_mgs: data.mgs,
          });
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: true,
          server_error: true,
          error_mgs: "En ukjent feil har oppstått, prøv igjen senere.",
        });
      });
  }

  generateStylesheet(hex) {
    var styles = "";
    if (hex) {
      const colorThemeProperties = f7.utils.colorThemeCSSProperties(hex);
      if (Object.keys(colorThemeProperties).length) {
        styles += `
            body {
            ${Object.keys(colorThemeProperties)
              .map((key) => `${key}: ${colorThemeProperties[key]} !important;`)
              .join("\n  ")}
            }`;
      }
    }
    return styles.trim();
  }

  setColorTheme(hex) {
    var self = this;
    if (hex && stylesheet) {
      stylesheet.innerHTML = self.generateStylesheet(hex);
    }
  }

  render() {
    return this.state.loading ? (
      <Page>
        <div
          className="text-align-center"
          style={{ marginTop: "36px", marginBottom: "160px" }}
        >
          <Preloader></Preloader>
        </div>
      </Page>
    ) : this.state.error ? (
      this.state.server_error ? (
        <Page>
          <PageBlock width="520px">
            <BlockTitle className="text-align-center">
              Vi har problemer.
            </BlockTitle>
            <Block className="text-align-center">
              <p>
                Vi har for øyeblikket problemer med å koble til våre servere, så
                vi kan ikke vise dette arrangementet. Vi jobber nå med å løse
                problemet.
              </p>

              <p>Prøv å last inn siden på nytt igjen om 1 – 2 minutter.</p>
            </Block>
            <div
              style={{
                width: "100%",
                maxWidth: "240px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <Button
                onClick={() => {
                  this.loadXhr();
                }}
                large
                outline
              >
                Last inn på nytt
              </Button>
            </div>
            <br />
            <Block className="text-align-center">
              <p>
                <b>
                  Har du fremdeles problemer?
                  <br />
                  Ta kontakt til <b>post@iwd.no</b>, så hjelper vi deg.
                </b>
              </p>
            </Block>
          </PageBlock>
        </Page>
      ) : (
        <Page>
          <PageBlock width="920px">
            <Card style={{ color: "#fff", backgroundColor: "#e74c3c" }}>
              <CardContent>
                <Icon
                  material="error"
                  style={{ marginRight: "12px", marginTop: "-5px" }}
                />
                <span style={{ fontSize: "18px" }}>{this.state.error_mgs}</span>
              </CardContent>
            </Card>
          </PageBlock>
        </Page>
      )
    ) : (
      this.state.data.options.layout === 1 && (
        <Page className={this.state.data.options.theme === 2 && "dark"}>
          <PageBlock width="920px">
            <Ev1La1
              data={this.state.data}
              eid={this.props.f7route.params.id}
              reload_event={this.loadXhr.bind(this)}
            />
          </PageBlock>
        </Page>
      )
    );
  }
}
